import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default async function(context, inject) {
  if (process.server) return false

  const fingerprint = await FingerprintJS.load()
  const result = await fingerprint.get()

  inject('fingerprint', result)
}
